import axiosInstance from './api';

const requestAQuoteService = {
    requestAQuote(data) {
        return axiosInstance.post('/request-a-quote', data).catch(console.error);
    },
};

export default requestAQuoteService;
